<template>
  <div class="payment-details">
    <h4>Payment Details</h4>
    <div class="payment-info">
      <p><strong>Only send fees in Azadi Coin (AC):</strong></p>
      <ul>
        <li>
          If you send any other token types, your request will not be processed.
        </li>
        <li>Supported network: Solana</li>
      </ul>
      <p><strong>Fee receiving address:</strong></p>
      <div>
        - Solana fee address:
        <p class="fee-address">DHsa1EqYrCxuGBa3irMhR48Vd95vBfsguP8Aou9L9sDA</p>
      </div>
      <p class="mt-2">
        After the payment, provide screenshot of the transaction.
      </p>
    </div>
    <form @submit.prevent="submitPaymentDetails">
      <!-- <div class="form-group">
        <label for="transaction-link">Transaction Link/Hash *</label>
        <input
          type="text"
          id="transaction-link"
          v-model="transactionLink"
          placeholder="Enter transaction link or hash"
          required
        />
      </div> -->
      <div class="form-group">
        <label for="transaction-link-ss">Screenshot of the Transaction <span class="red">*</span></label>
        <input
          type="file"
          id="transaction-link-ss"
          accept="image/*"
          placeholder="Enter transaction link or hash"
          @change="fileUpload"
        />
      </div>
      <div class="action-btn">
        <button type="submit" class="submit-btn">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      // transactionLink: "",
      transaction_screenshot: null,
    };
  },
  methods: {
    async fileUpload(event) {
      this.transaction_screenshot = event.target.files[0];
      console.log(event.target.files[0])
    },
    async submitPaymentDetails() {
      if (!this.transaction_screenshot) {
         window.toastr.error("Screenshot of the Transaction is required.", null, {timeOut: 1000, positionClass: 'toast-bottom-center'});
        return;
      }
      const currentDate = new Date();
      const formattedDate =
        currentDate.getFullYear() +
        "-" +
        String(currentDate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(currentDate.getDate()).padStart(2, "0");
      try {
        const formData = new FormData();
        formData.append('course_id', this.$route.params.id);
        formData.append('start_date', formattedDate);
        // formData.append('hash', this.transactionLink);
        if(this.transaction_screenshot)
        formData.append('transaction_screenshot', this.transaction_screenshot);
        const res = await axios.post("user/enrollment", formData);
        console.log(res)
        if(res.data.status === false) {
          window.toastr.error(res.data.message, null, {timeOut: 1000, positionClass: 'toast-bottom-center'});
        }
        else {
        this.$emit("formsubmit");
        }
      } catch (err) {
        console.log(err);
      }
      
      // Add logic for form submission
    },
  },
};
</script>

<style scoped>
.payment-details {
  max-width: 60rem;
  margin: 2rem auto;
  padding: 2rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: left;
}
.payment-details h4 {
  margin-bottom: 1.5rem;
  text-align: left;
  font-size: 1.1rem;
  font-family: 'GothicB';
}
.payment-info {
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
}
.payment-info strong {
  font-weight: 800;
  font-family: 'GothicB';
}
.payment-info ul {
  margin: 0.5rem 0 1rem 1.2rem;
  padding-left: 0;
  list-style-type: disc;
}
.fee-address {
  font-weight: bold;
  padding: 0.5rem 0;
  display: inline-block;
  border-radius: 4px;
  font-size: 1rem;
  word-break: break-all;
}
.form-group {
  margin-bottom: 1.5rem;
}
.form-group label {
  margin-bottom: 0.5rem;
  display: block;
  font-family: 'GothicB';
  font-size: 0.9rem;
}
.form-group input {
  width: 100%;
  padding: 0.5rem;
  border-radius: 5px;
  background-color: #e5e5e5;
  border: 1px solid #ccc;
  color: gray;
}
.mt-2 {
  margin-top: 1rem;
}
.action-btn {
  text-align: left;
}
.submit-btn {
  padding: 0.6rem 2rem;
  background-color: #f0c57a;
  color: #000;
  border: 1px solid #f0ba7c;
  outline: none;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.6rem 2rem;
  font-family: 'Gothic';
}
.submit-btn:hover {
  background-color: #ddb467;
}
.red {
  color: red;
}
</style>
